export default __webpack_public_path__ + "static/media/demo_histology.0611ffe5.jpg";